<template>
  <div class="download">
    <section class="action1">
      <div class="container contactv1">
        <div class="row">
          <div class="col-md-9 col-sm-9 col-xs-12">
            <h3>{{ title }}</h3>
          </div>
          <div class="col-md-3 col-sm-3 col-xs-12">
            <div class="garden-button">
              <a :href="link" target="_blank" class="readmore2">{{
                buttonTitle
              }}</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Download",
  props: {
    title: String,
    buttonTitle: String,
    link: String
  }
};
</script>

<style scoped lang="scss">
.action1 {
  background: rgba(53, 119, 180, 1);
  background: -moz-linear-gradient(
    -45deg,
    rgba(53, 119, 180, 1) 0%,
    rgba(90, 215, 217, 1) 100%
  );
  background: -webkit-gradient(
    left top,
    right bottom,
    color-stop(0%, rgba(53, 119, 180, 1)),
    color-stop(100%, rgba(90, 215, 217, 1))
  );
  background: -webkit-linear-gradient(
    -45deg,
    rgba(53, 119, 180, 1) 0%,
    rgba(90, 215, 217, 1) 100%
  );
  background: -o-linear-gradient(
    -45deg,
    rgba(53, 119, 180, 1) 0%,
    rgba(90, 215, 217, 1) 100%
  );
  background: -ms-linear-gradient(
    -45deg,
    rgba(53, 119, 180, 1) 0%,
    rgba(90, 215, 217, 1) 100%
  );
  background: linear-gradient(
    135deg,
    rgba(53, 119, 180, 1) 0%,
    rgba(90, 215, 217, 1) 100%
  );
  background-size: cover;
  background-position: center;
  padding: 20px 0;
}
.contactv1 {
  border: 1px solid #f9f9f9;
  padding: 30px 15px;
  border-style: dashed;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
}
.contactv1 h3 {
  font-family: "Poppins", sans-serif;
  font-size: 30px;
  color: #f9f9f9;
  padding: 20px;
}
@media (min-device-width: 320px) and (max-device-width: 480px) {
  .contactv1 h3 {
    font-size: 24px !important;
    text-align: center;
    line-height: 50px;
  }
  .readmore2 {
    margin-left: 120px;
  }
}
@media (max-device-width: 320px) {
  .contactv1 h3 {
    font-size: 20px !important;
    text-align: center;
    line-height: 50px;
  }
  .readmore2 {
    margin-left: 70px;
  }
}
</style>
